import React from 'react';

const originCreateElement = React.createElement;

if (process.env.NODE_ENV === 'development') {
  React.createElement = function (type: React.ElementType, props: any, ...children: any[]) {
    if (typeof type === 'string' && props?.__source) {
      const srcIndex = props.__source.fileName?.indexOf('src');
      // eslint-disable-next-line no-param-reassign
      props.__source_file__ = props.__source.fileName.substr(srcIndex);
    }
    return originCreateElement(type, props, ...children);
  } as any;
}
